import { useState } from "react";
import { ImageIcon } from "lucide-react";
import EvolutionTimeline from "@/components/diagrams/EvolutionTimeline";
import TokenizerPlayground from "@/components/diagrams/TokenizerPlayground";
import ContextBudget from "@/components/diagrams/ContextBudget";
import EvidenceRouter from "@/components/diagrams/EvidenceRouter";
import DataBlindArchitecture from "@/components/diagrams/DataBlindArchitecture";
import ArchitecturePatterns from "@/components/diagrams/ArchitecturePatterns";
import OeeCalculator from "@/components/diagrams/OeeCalculator";
import PromptBuilder from "@/components/diagrams/PromptBuilder";
import RoadmapStepper from "@/components/diagrams/RoadmapStepper";
import HandoverFlow from "@/components/diagrams/HandoverFlow";
import CapstoneFlow from "@/components/diagrams/CapstoneFlow";

const INTERACTIVE = {
  evolution: EvolutionTimeline,
  tokenizer: TokenizerPlayground,
  "context-budget": ContextBudget,
  "evidence-router": EvidenceRouter,
  "data-blind": DataBlindArchitecture,
  "arch-patterns": ArchitecturePatterns,
  "oee-tree": OeeCalculator,
  "prompt-structure": PromptBuilder,
  roadmap: RoadmapStepper,
  handover: HandoverFlow,
  capstone: CapstoneFlow,
};

export const LessonVisual = ({ visual }) => {
  const [showRef, setShowRef] = useState(false);
  if (!visual) return null;
  const Comp = INTERACTIVE[visual.key];
  return (
    <figure data-testid="lesson-visual" className="my-10 border border-border bg-muted/30 p-4 sm:p-6">
      {Comp && <Comp />}
      {visual.src && (
        <div className="mt-5">
          <button type="button" data-testid="lesson-visual-reference-toggle" onClick={() => setShowRef(!showRef)} className="inline-flex items-center gap-2 font-body text-xs font-semibold text-muted-foreground hover:text-foreground">
            <ImageIcon className="h-3.5 w-3.5" /> {showRef ? "Hide" : "Show"} reference diagram
          </button>
          {showRef && <img src={visual.src} alt={visual.alt} className="mt-3 w-full rounded-sm bg-white object-contain" loading="lazy" />}
        </div>
      )}
      <figcaption className="mt-4 font-body text-sm text-muted-foreground">{visual.alt}</figcaption>
    </figure>
  );
};
